export class RouteConstant {
    static readonly APP_CONST_EMPTY = '';
    static readonly APP_CONST_SECURE = 'secure';
    static readonly APP_CONST_ACCESSDENIED = 'access-denied';
}
